const RU_HOST_META_NAME = 'egb-ru-host';

export const isInjectedRuHost = (): boolean => {
    const meta = document.querySelector(`meta[name="${RU_HOST_META_NAME}"]`);

    return meta?.getAttribute('content') === 'true';
};
